<template>
    <div class="ksBox">
        <div class="searchItem flex fle-item flex-just">
            <div class="item">
                <el-input
                        class="mr10"
                        placeholder="名称/信用代码 搜索"
                        v-model="gsinput"
                        clearable>
                </el-input>
                <el-select class="mr10" v-model="state" placeholder="请选择">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-button type="primary" @click="searchData">检索</el-button>
            </div>
            <div class="item-right flex">
                <div class="uploadFile">
                    <el-button type="info" class="uploadBtn">上传文件</el-button>
                    <input  type="file" name="files" value="" id="uploadfile2" multiple="multiple" accept=".xls"
                            class="upload-input uploadfile1" @change="importFile">
                </div>
                <div class="xz">
                    <el-button type="primary">新增</el-button>
                </div>
            </div>

        </div>
        <!--      表格-->
        <div class="dataTable mt20">
            <template>
                <el-table
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                    <el-table-column
                            align="center"
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            prop="i_fid"
                            align="center"
                            label="编码"
                            width="100">
                    </el-table-column>
                    <el-table-column
                            prop="vc_name"
                            align="center"
                            label="名称"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_app"
                            align="center"
                            label="订阅系统"
                            width="100"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_state"
                            align="center"
                            label="状态"
                            width="80"
                            :formatter="State"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width="120"
                            prop="vc_bzstyle"
                            align="center"
                            label="包装规格"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width="80"
                            prop="f_weight"
                            align="center"
                            label="单件净重"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width="80"
                            prop="vc_unit"
                            align="center"
                            label="单位"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_cd"
                            align="center"
                            label="产地"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_gykh"
                            align="center"
                            label="厂家"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            width="100"
                            prop="vc_type"
                            align="center"
                            label="货物性质"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="dt_importtime"
                            align="center"
                            label="时间"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="操作"
                            width="160">
                        <template slot-scope="scope">
                            <!--                                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>-->
<!--                            <el-button type="text" size="small" style="color: #67C23A" v-if="scope.row.vc_state=='002'" @click="relationData(scope.row)">取消关系 |</el-button>-->
                            <el-button type="text" size="small" style="color: #67C23A" v-if="scope.row.vc_state=='003'" @click="editData(scope.row)">编辑  |</el-button>
                            <el-button type="text" size="small">发布 | </el-button>
                            <el-button type="text" size="small" style="color: #F56C6C">归档</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="tableBottom flex fle-item flex-just mt20">
                    <div class="tbLeft">
                        <el-button type="primary">批量发布</el-button>
                        <el-button type="primary">批量归档</el-button>
                    </div>
                    <div class="tbRight">
                        <div class="paginationBox textRig" >
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    @current-change="pageCurrentChange"
                                    :current-page.sync="currentPage"
                                    :total="tableTotal">
                            </el-pagination>
                        </div>
                    </div>
                </div>

            </template>
        </div>
        <el-dialog title="数据编辑" :model="GetData" ref="GetData" :visible.sync="dialogFormVisibleData" v-if="dialogFormVisibleData" @close="cancelData" :close-on-click-modal="false" width="1250px" height="500px">
            <el-row>
                <el-col :span="12">
                    <h3> 业务数据 ({{GetData.vc_app}})</h3>
                    <div class="grid-content ">
                        <div>
                            <span class="dataSpan" >编码:</span>
                            <span >{{GetData.i_fid}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">名称:</span>
                            <span >{{GetData.vc_name}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">包装规格:</span>
                            <span  >{{GetData.vc_bzstyle}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">单件净重:</span>
                            <span  >{{GetData.f_weight}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">单位:</span>
                            <span  >{{GetData.vc_unit}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">产地:</span>
                            <span  >{{GetData.vc_cd}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">厂家:</span>
                            <span  >{{GetData.vc_gykh}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">货物性质:</span>
                            <span  >{{GetData.vc_type}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">账套:</span>
                            <span  >{{GetData.vc_user}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12" :data=" currentRow" >
                    <h3 > 主数据</h3>
                    <div class="grid-content " v-if="currentRow">
                        <div>
                            <span class="dataSpan" >编码:</span>
                            <span >{{currentRow.i_fid}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">名称:</span>
                            <span >{{currentRow.vc_name}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">包装规格:</span>
                            <span  >{{currentRow.vc_bzstyle}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">单件净重:</span>
                            <span  >{{currentRow.f_weight}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">单位:</span>
                            <span  >{{currentRow.vc_unit}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">产地:</span>
                            <span  >{{currentRow.vc_cd}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">厂家:</span>
                            <span  >{{currentRow.vc_gykh}}</span>
                        </div>
                        <div>
                            <span class="dataSpan">货物性质:</span>
                            <span  >{{currentRow.vc_type}}</span>
                        </div>
                        <!--<div>
                            <span class="dataSpan">账套:</span>
                            <span  >{{currentRow.vc_user}}</span>
                        </div>-->
                    </div>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer" 　style="text-align: center;">
<!--                <el-button type="primary" @click="chooseData=true" >选择主数据</el-button>-->
                <el-button type="primary" @click="tipsRelation" v-bind:disabled="isRelation">创建关系</el-button>
                <div class="item" >
                    <el-input
                            class="mr10"
                            placeholder="产品名称 搜索"
                            v-model="zsjinput"
                            clearable>
                    </el-input>
                    <el-button type="primary" @click="searchZsj">检索</el-button>
                </div>
                <el-table tooltip-effect="dark" align="center" max-height="250" ref="singleTable" :data="GetChooseData"   @current-change="handleCurrentChangeZsj" highlight-current-row>
                    <el-table-column width="100" property="i_fid" label="编码" align="center"></el-table-column>
                    <el-table-column width="" property="vc_name" label="名称" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" property="vc_app" label="订阅系统" align="center"></el-table-column>
                    <el-table-column width="100" property="vc_bzstyle" label="包装规格" align="center"></el-table-column>
                    <el-table-column width="100" property="f_weight" label="单件净重" align="center"></el-table-column>
                    <el-table-column width="" property="vc_cd" label="产地" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column width="" property="vc_gykh" label="厂家" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column width="" property="vc_type" label="货物类型" align="center"show-overflow-tooltip></el-table-column>
                    <el-table-column width="" property="vc_unit" label="单位" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column width="" property="dt_importtime" label="时间" align="center" show-overflow-tooltip></el-table-column>
<!--                    <el-table-column width="" property="vc_user" label="地址"></el-table-column>-->
                </el-table>
<!--                <el-button type="primary" v-if="chooseDataList" @click="makeZsj" style="margin-top: 20px;">确定</el-button>-->
            </div>
        </el-dialog>
        <el-dialog title="关联数据"  :visible.sync="dialogFormVisibleDataR" v-if="dialogFormVisibleDataR" @close="cancelDataR" :close-on-click-modal="false" width="1250px" height="500px">
            <el-table tooltip-effect="dark" align="center"  ref="singleTable" :data="GetChooseDataR"   @current-change="handleCurrentChangeZsj" highlight-current-row>
                <el-table-column width="100" property="i_fid" label="编码" align="center"></el-table-column>
                <el-table-column width="" property="vc_name" label="名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column width="" property="vc_app" label="订阅系统" align="center"></el-table-column>
                <el-table-column width="" property="i_sysid" label="主数据id" align="center"></el-table-column>
                <el-table-column width="" property="i_appid" label="业务数据id" align="center"></el-table-column>
                <!--<el-table-column width="100" property="vc_bzstyle" label="包装规格" align="center"></el-table-column>
                <el-table-column width="100" property="f_weight" label="单件净重" align="center"></el-table-column>
                <el-table-column width="" property="vc_cd" label="产地" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column width="" property="vc_gykh" label="厂家" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column width="" property="vc_type" label="货物类型" align="center"show-overflow-tooltip></el-table-column>-->
                <el-table-column width="" property="dt_createtime" label="时间" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column width="120" property="vc_user" align="center" label="账套"></el-table-column>
                <!--<el-table-column
                        align="center"
                        label="操作"
                        width="">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" style="color: #67C23A" @click="noRelation(scope.row)">取消关系</el-button>
                    </template>
                </el-table-column>-->
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from  "./api";
    import {filerequest_url} from './api';
    import {mapActions} from "vuex";
    export default {
        name: "index",
        data(){
            return{
                chooseDataList:false,
                chooseData:false,
                isRelation:true,
                isHandle:false,
                state:"003",
                options: [{
                    value: '002',
                    label: '已处理'
                }, {
                    value: '003',
                    label: '异常'
                }],
                GetData:{
                    i_fid:"",
                    vc_app:"",
                    vc_name:"",
                    //vc_creditcode:"",
                    vc_bzstyle:"",
                    f_weight:"",
                    vc_cd:"",
                    vc_gykh:"",
                    vc_type:"",
                    vc_unit:"",
                    vc_user:"",
                },
                /*GetChooseData:{
                    i_fid:"",
                    vc_app:"",
                    vc_name:"",
                    //vc_creditcode:"",
                    vc_bzstyle:"",
                    f_weight:"",
                    vc_cd:"",
                    vc_gykh:"",
                    vc_type:"",
                    vc_unit:"",
                    vc_user:"",
                },*/
                GetChooseData:[],
                GetChooseDataR:[],
                dialogFormVisibleData:false,
                dialogFormVisibleDataR:false,
                gsinput:"",
                zsjinput:"",
                fileName:"",
                fileType:"",
                fileUrl:"",
                value:"",
                i_uid:"",
                tableData: [],
                tableTotal:0,
                pageSize:1,
                currentPage:1,
                glData:[],
                i_id:"",
                qi_id:"",
                qvc_user:"",
                //qvc_creditcode:"",
                qvc_name:"",
                qi_fid:"",
                yi_id:"",
                qvc_app:"",
                zColor:"backColor",
                cColor:"backColor",
                currentRow: null,
                zi_id:"",
            }
        },
        mounted() {
            this.getMDataMessage();
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            async getMDataMessage(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    page_count:10,
                    search:this.gsinput,
                    vc_state:this.state,
                    i_type: 8,
                    tableData: [],
                };
                let res=await API.getMDataMessage(param);
                if(res.code==1){
                    //console.log("res",res);
                    this.tableData= res.data;
                    this.tableTotal=res.count;
                } else if (res.code == -2) {
                   this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },
            async searchZsj(){
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    page_count:10,
                    search:this.zsjinput,
                    vc_state:this.state,
                    i_type: 8,
                    tableData: [],
                };
                let res=await API.getEditMessage(param);
                if(res.code==1){
                    this.chooseDataList=true;
                    //console.log("res",res);
                    this.GetChooseData= res.data;
                    //console.log("GetChooseData",this.GetChooseData);
                    this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            async searchPZdata(){
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    page_count:10,
                    search:this.gsinput,
                    vc_state:this.state,
                    i_type: 8,
                    tableData: [],
                };
                let res=await API.getMDataMessage(param);
                if(res.code==1){
                    //console.log("res",res);
                    this.tableData= res.data;
                    this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            //上传文件
            async importFile(value){
                // console.log(value.target.files);
                let _this=this;
                let $files=value.target.files[0];
                let fileName=$files.name;
                var type = fileName.substring(fileName.lastIndexOf('.') + 1);
                const extension = type === 'xls' ;
                if ($files && extension==false) {
                    this.$message.error('请上传格式正确的文件');
                    return;
                };
                if($files){
                    _this.fileName=$files.name;
                    //_this.fileUrl=window.URL.createObjectURL(value.target.files[0]);
                    // console.log("$files",$files)
                }else{
                    _this.fileName="";
                    //_this.fileUrl="";
                }
                if(_this.fileName) {
                    document.getElementById('uploadfile2').value = null;
                    let param = {
                        "myFile": $files,
                        "token": sessionStorage.getItem("token"),
                        "i_uid": sessionStorage.getItem("userid"),
                        "app":"masterdata",
                        "version":"1.0",
                        "myFileFileName": _this.fileName,
                        "i_type": 8,
                    };
                    // console.log($files,"$files");
                    let FD = new FormData();
                    // FD.file=$files;

                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    let res = await  fetch(filerequest_url, {
                        method:"post",
                        body:FD
                    }).then(res=>res.text());
                    res =JSON.parse(res);
//                    console.log(res.code,"res");
                    if(res.code == 1){
                        _this.$message({
                            type:'success',
                            message:'导入成功'
                        })
                    }else{
                        _this.$message({
                            type:'error',
                            message:res.message
                        })
                    }

                }
            },
            async editData(value){
//                console.log("value",value);
                this.currentRow="";
                this.isHandle=false;
                this.isRelation=true;
                this.qi_id=value.i_id;
                this.qi_fid=value.i_fid;
                this.qvc_app=value.vc_app;
                this.qvc_user=value.vc_user;
                this.qvc_name=value.vc_name;
                this.GetData.i_fid=value.i_fid;
                this.GetData.vc_name=value.vc_name;
                this.GetData.vc_bzstyle=value.vc_bzstyle;
                this.GetData.f_weight=value.f_weight;
                this.GetData.vc_cd=value.vc_cd;
                this.GetData.vc_gykh=value.vc_gykh;
                this.GetData.vc_unit=value.vc_unit;
                this.GetData.vc_type=value.vc_type;
                this.GetData.vc_user=value.vc_user;
                this.GetData.vc_app=value.vc_app;
                this.dialogFormVisibleData=true;
                console.log("qvc_name",this.qvc_name);
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    page_count:10,
                    search:this.qvc_name,
                    vc_state:this.state,
                    i_type: 8,
                    tableData: [],
                };
                let res=await API.getEditMessage(param);
                if(res.code==1){
                    this.zsjinput=this.qvc_name;
                    this.chooseDataList=true;
                    //console.log("res",res);
                    this.GetChooseData= res.data;
                    //console.log("GetChooseData",typeof this.GetChooseData);
                    //this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
                /*let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    vc_name:value.vc_name,
                    i_type: 8,
                    //vc_creditcode:value.vc_creditcode,
                };
                let res=await API.getEditMessage(param);
                if(res.code==1){
                    //this.glData=res.data;
                    this.yi_id=res.data[0].i_id;
                    //this.vc_creditcode=res.data[0].vc_creditcode;
                    this.vc_name=res.data[0].vc_name;

                    if(this.qvc_name!=this.vc_name){
                        this.zColor="redColor";
                    }
                    // console.log("qvc_creditcode",this.qvc_creditcode,this.vc_creditcode);
                    // console.log("qvc_name",this.qvc_name,this.vc_name);
                } else if (res.code == -2) {
                    // this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };*/
            },
            async relationData(value){
//                console.log("value",value);
                this.currentRow="";
                this.isHandle=false;
                this.isRelation=true;
                this.qi_id=value.i_id;
                this.qi_fid=value.i_fid;
                this.qvc_app=value.vc_app;
                this.qvc_user=value.vc_user;
                this.qvc_name=value.vc_name;
                /*this.GetData.i_fid=value.i_fid;
                this.GetData.vc_name=value.vc_name;
                this.GetData.vc_bzstyle=value.vc_bzstyle;
                this.GetData.f_weight=value.f_weight;
                this.GetData.vc_cd=value.vc_cd;
                this.GetData.vc_gykh=value.vc_gykh;
                this.GetData.vc_unit=value.vc_unit;
                this.GetData.vc_type=value.vc_type;
                this.GetData.vc_user=value.vc_user;
                this.GetData.vc_app=value.vc_app;*/
                this.dialogFormVisibleDataR=true;
                //console.log("qvc_name",this.qvc_name);
                let param={
                    i_id:this.qi_id,
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    //page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    //page_count:10,
                    //search:this.qvc_name,
                    //vc_state:this.state,
                    i_type: 8,
                    //tableData: [],
                };
                let res=await API.getMDataDetails(param);
                if(res.code==1){
                    this.zsjinput=this.qvc_name;
                    //this.chooseDataList=true;
                    //console.log("res",res);
                    this.GetChooseDataR= res.data;

                    //console.log("GetChooseData",typeof this.GetChooseData);
                    //this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },
            tipsRelation(){
                if(this.qvc_name!=this.vc_name){
                    this.$confirm('存在不相同数据确定要创建关系?','提示',{
                        confirmButtonText:'确定',
                        cancelButtonText:'取消',
                        type:'warning'
                    }).then(()=>{
                        this.isRelation=true;
                        this.relationship();
                    }).catch(()=>{
                        this.$message({
                            type:'info',
                            message:'已取消'
                        })
                    })
                }else {
                    this.isRelation=true;
                    this.relationship();
                }
            },
            async relationship(){
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    vc_name:this.vc_name,
                    i_type: 8,
                    //vc_creditcode:this.vc_creditcode,
                    i_sysid:this.zi_id,
                    i_appid:this.qi_id,
                    vc_app:this.qvc_app,
                    i_fid:this.qi_fid,
                    vc_user:this.qvc_user,
                };
                let res=await API.saveMDRelation(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.getMDataMessage();
                    this.dialogFormVisibleData=false;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },

            cancelData(){
                this.dialogFormVisibleData=false;
                this.cColor="backColor";
                this.zColor="backColor";
                this.currentRow="";
                this.GetChooseData=[];
                this.chooseDataList=false;
                this.chooseData=false;
            },
            cancelDataR(){
                this.dialogFormVisibleDataR=false;
                this.GetChooseDataR=[];
            },
            State(row, column, cellValue, index){
                if(row.vc_state==='002'){
                    return '已处理'
                }else if(row.vc_state==='003'){
                    return '异常'
                }
            },
            pageCurrentChange(val){
                this.pageSize=val;
                this.currentPage=val;
                this.getMDataMessage();
            },
            searchData(){
                this.pageSize=1;
                this.currentPage=1;
                this.searchPZdata();
            },
            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                // console.log(val)
            },
            handleCurrentChangeZsj:function(val) {
                this.currentRow  = val;
                console.log(val)
                if(this.currentRow!=null && this.currentRow!=""){
                    //this.glData=this.currentRow;
                    this.zi_id=this.currentRow.i_id;
                    this.chooseDataList=false;
                    this.chooseData=false;
                    this.isRelation=false;
                }
            },
            makeZsj:function () {
                if(this.currentRow!=null && this.currentRow!=""){
                    //this.glData=this.currentRow;
                    this.zi_id=this.currentRow.i_id;
                    this.chooseDataList=false;
                    this.chooseData=false;
                    this.isRelation=false;
                }else {
                    this.$message.warning("请选择主数据");
                }
               console.log("glData",this.currentRow)
            },
        },
    }
</script>

<style lang="scss"  scoped>
    .flex{
        display: flex;
    }
    .fle-item{
        align-items: center;
    }
    .flex-just{
        justify-content: space-between;
    }
    .mr10{
        margin-right: 10px;
    }
    .mt20{
        margin-top: 20px;
    }
    .ksBox{
        height: 100%;
        margin-top: 20px;
    }
    .searchItem{
        .item{
            width: 30%;
            /deep/{


            }
        }
        .item-right{
            margin-right: 40px;
            .xz{
                margin-left: 10px;
            }
        }
    }
    .uploadFile{
        /*height: 80px;*/
        overflow: hidden;
        position: relative;
        .uploadBtn{
            width: 150px;
        }
        .upload-input{
            width: 150px;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
        }
    }
    .dataSpan{
        width: 100px;
        display: inline-block;
        padding-top: 10px;
    }
    .backColor{
        color: #606266;
    }
    .redColor{
        color: red;
    }
    /deep/{
        .el-dialog{
            font-size: 20px;
        }
        .el-dialog__header{
        background-color: #3e82e8;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
        }
    }
</style>